<template>
  <div class="payment-summary">
    <b-card no-body style="max-width: 200rem">
      <h4 v-if="this.$store.state.curDocType != 4" slot="header">
        Resumen {{ DocText }} {{ curOrder }}
      </h4>
      <h4 v-if="this.$store.state.curDocType == 4" slot="header">
        Cobro {{ paymentDocText }} {{ curOrder }}
      </h4>
      <b-list-group-item
        v-if="this.$store.state.curDocType != 4"
        variant="primary"
      >
        <b-form-checkbox
          id="checkbox1"
          v-model="CombineShipments"
          value="1"
          unchecked-value="0"
          disabled
        >
          Fact. automática
        </b-form-checkbox>
      </b-list-group-item>
      <b-list-group flush>
        <b-list-group-item v-if="this.$store.state.curDocType != 4"
          >Subtotal:{{ OrderTotal }}</b-list-group-item
        >
        <b-list-group-item v-if="this.$store.state.curDocType != 4"
          >Descuento:{{ OrderDiscAmount }}</b-list-group-item
        >
        <b-list-group-item v-if="this.$store.state.curDocType != 4"
          >Impuestos:{{ OrderTotalVAT }}</b-list-group-item
        >
        <b-list-group-item>Total:{{ OrderTotalIncVAT }}</b-list-group-item>
      </b-list-group>
      <b-card-body v-if="CombineShipments == 0" title="Forma de pago">
        <b-table striped hover :items="paymMethods" :fields="fields"></b-table>
      </b-card-body>
      <b-card-footer v-if="CombineShipments == 0"
        >Total Pagado:{{ OrderTotalPaym }}</b-card-footer
      >
    </b-card>
  </div>
</template>

<script>
import mixin from "@/components/mixin.js";

export default {
  mixins: [mixin],
  name: "PaymentSummary",
  data() {
    return {
      options: [],
      CurrentAmount: 0,
      fields: [
        {
          key: "paymdate",
          label: "Fecha",
          formatter: (value) => {
            var event = new Date(value);
            var options = { year: "numeric", month: "numeric", day: "numeric" };
            return event.toLocaleDateString("es-ES", options);
          },
        },
        { key: "paymenttype", label: "Forma de Pago" },
        { key: "amount", label: "Importe" },
        {
          key: "anticipo",
          label: "Anticipo",
          formatter: (value) => {
            return value == true ? "Si" : "No";
          },
        },
        { key: "voucherNo", label: "Vale" },
      ],
    };
  },
  created: function () {
    this.CurrentAmount = parseFloat(
      this.$store.getters.OrderTotalIncVAT
    ).toFixed(2);
    localStorage.setItem("totalAmount", this.CurrentAmount);
  },
  computed: {
    paymMethods() {
      return this.$store.state.paymMethods;
    },
    curOrder() {
      return this.$store.state.curOrder;
    },
    CombineShipments() {
      return this.$store.state.orderproperties.CombineShipments;
    },
    OrderTotalPaym() {
      return this.$store.getters.OrderTotalPaym;
    },
    paymentDocText() {
      return this.$store.state.paymentDocType == 2 ? "Factura" : "Abono";
    },
    DocText() {
      return this.$store.state.curDocType == 5 ? "devolución" : "venta";
    },
  },
  mounted: function () {},
  methods: {},
};
</script>